import { useContext, useEffect, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, KrLandslideFormTypes, NavHeadingsKROEnum, landSlideAttributes } from "../../../../contexts/krFormContext";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { FormFieldProps } from "../../../../components/formField/types/formFieldProps";
import FormField from "../../../../components/formField/formField";
import TextWithCheckboxField from "../../../../components/textWithCheckboxField/textWithCheckboxField";
import { TextWithCheckBoxFieldProps } from "../../../../components/textWithCheckboxField/types/textWithCheckboxFieldProps";
import { configValidation, createConfigValidation, createConfigValidationWarnings, FormulaMsg, toFormulaConfig, validation } from "../../../../helpers/validation/validation";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { GetOptions, prepareDataSingleForSelect } from "../../../../helpers/prepareForSelect";
import { PatternType } from "../../../../contexts/types/card";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { CalcField } from "../../../../helpers/form/calcField";


const MorfologicalParameters = (props: FormSectionProps) => {

    const checkIfHasValue = (value: string | undefined | null) => {
        if (value !== undefined && value !== "" && value !== "Nie stwierdzono" && value != null) {
            return false;
        }
        return true;
    }
    

    const checkIfHasAnotherValue = (value: string | undefined | null) => {
        if (value !== undefined && value !== "" && value !== "Nie występują" && value != null) {
            return false;
        }
        return true;
    }

    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;

    const isFormNotValid =  krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false;
    var [gapsFound, setGapsFound] = useState(checkIfHasValue(krForm.landslideAttributes?.sG_SZCZELINY));
    const [pristineGaps, setPristineGaps] = useState(true);
    var [secondarySlopes, setSecondarySlopes] = useState(checkIfHasAnotherValue(krForm.landslideAttributes?.sG_SKARPY_WTORNE));
    const [pristineSecondarySlopes, setPristineSecondarySlopes] = useState(true);
    const [configValidationSlopeLength, setConfigValidationSlopeLength] = useState<configValidation>({});
    const [configValidationSlopeLengthWarnings, setConfigValidationSlopeLengthWarnings] = useState<configValidation>({});
    const [errorTipSlopeLength, setErrorTipSlopeLength] = useState<string>();
    const [configValidationSlopeHeight, setConfigValidationSlopeHeight] = useState<configValidation>({});
    const [configValidationSlopeHeightWarnings, setConfigValidationSlopeHeightWarnings] = useState<configValidation>({});
    const [errorTipSlopeHeight, setErrorTipSlopeHeight] = useState<string>();
    const [configValidationKoluviumLength, setConfigValidationKoluviumLength] = useState<configValidation>({});
    const [configValidationKoluviumLengthWarning, setConfigValidationKoluviumLengthWarning] = useState<configValidation>({});
    const [configValidationNachylenieStok, setConfigValidationNachylenieStok] = useState<configValidation>({});
    const [configValidationNachylenieStokWarning, setConfigValidationNachylenieStokWarning] = useState<configValidation>({});
    const [configValidationRozpietoscWarning, setConfigValidationRozpietoscWarning] = useState<configValidation>({});
    const [configValidationMainLength, setConfigValidationMainLength] = useState<configValidation>({});
    const [errorTipMainLength, setErrorTipMainLength] = useState<string>();
    const [configValidationMaxLength, setConfigValidationMaxLength] = useState<configValidation>({});
    const [errorTipMaxLength, setErrorTipMaxLength] = useState<string>();
    const [configValidationMinLength, setConfigValidationMinLength] = useState<configValidation>({});
    const [errorTipMinLength, setErrorTipMinLength] = useState<string>();
    const [configValidationMszac, setConfigValidationMszac] = useState<configValidation>({});
    const [configValidationMszacWarning, setConfigValidationMszacWarning] = useState<configValidation>({});
    const [errorTipMszac, setErrorTipMszac] = useState<string>();
    const [configValidationMpom, setConfigValidationMpom] = useState<configValidation>({});
    const [configValidationMpomWarning, setConfigValidationMpomWarning] = useState<configValidation>({});
    const [errorTipMpom, setErrorTipMpom] = useState<string>();
    const [configValidationNachylenieSkarpa, setConfigValidationNachylenieSkarpa] = useState<configValidation>({});
    const [errorTipNachylenieSkarpa, setErrorTipNachylenieSkarpa] = useState<string>();
    const [configValidationNachylenieKoluv, setConfigValidationNachylenieKoluv] = useState<configValidation>({});
    const [configValidationCzolo, setConfigValidationCzolo] = useState<configValidation>({});
    const [errorTipCzolo, setErrorTipCzolo] = useState<string>();
    const [rerender, setRerender] = useState(true);
    const [pristineNachylenieStok, setPristineNachylenieStok] = useState(true);
    const [pristineRozpietosc, setPristineRozpietosc] = useState(true);
    const [pristineSlopeLength, setPristineSlopeLength] = useState(true);
    const [pristineSlopeHeight, setPristineSlopeHeight] = useState(true);
    const [pristineKoluviumLength, setPristineKoluviumLength] = useState(true);
    const [pristineMainLength, setPristineMainLength] = useState(true);
    const [pristineMaxLength, setPristineMaxLength] = useState(true);
    const [pristineMinLength, setPristineMinLength] = useState(true);
    const [pristineNachylenieSkarpa, setPristineNachylenieSkarpa] = useState(true);
    const [pristineNachylenieKoluv, setPristineNachylenieKoluv] = useState(true);
    const [pristineMszac, setPristineMszac] = useState(true);
    const [pristineMpom, setPristineMpom] = useState(true);
    const [pristineCzolo, setPristineCzolo] = useState(true);
    const [reload, setReload] = useState(true);

    const [errorTipsText, setErrorTipsText] = useState<{ [key: string]: string | undefined }>({
        tyP_STOKU_SID: '',
    });

    var is2007 = krForm.landslideAttributes?.wersja === PatternType.P2007;
    var slopeTypeDict = is2007 ? GetOptions("TYP_STOKU_SID", krForm.dictionaries, true) : [];
    var exposureDirectionDict = is2007 ? GetOptions("KIERUNEK_EKSPOZYCJI_SID", krForm.dictionaries, true) : [];

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            for (const key of Object.keys(errorTipsText)) {
                setError(key);
            }
            setReload(!reload);
        }    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const setError = (key: string) => {
        const errorMsg = krForm.config?.ValidationError![key];
        if (errorMsg !== '') {
            var newErrorList = { ...errorTipsText, [key]: errorMsg };
            setErrorTipsText(newErrorList);
        }
    }

    useEffect(() => {
        const attrs = krForm.landslideAttributes;
        if (!attrs) return;

        var configValidation = createConfigValidation("sT_DLUGOSC", false, attrs?.oS_DLUGOSC, props.version, props.objectType);
        var configValidationWarnings = createConfigValidationWarnings("sT_DLUGOSC", false, attrs?.oS_DLUGOSC, props.version, props.objectType);
        setConfigValidationSlopeLength(configValidation);
        setConfigValidationSlopeLengthWarnings(configValidationWarnings);
        if (attrs?.oS_DLUGOSC !== null && attrs?.oS_DLUGOSC !== undefined &&
            attrs?.sT_DLUGOSC !== null && attrs?.sT_DLUGOSC !== undefined) {
            setErrorTipSlopeLength("")
        } else {
            if(!pristineSlopeLength) setErrorTipSlopeLength(validation(configValidation, attrs?.sT_DLUGOSC));
        }

        var configValidationHeight = createConfigValidation("sT_WYSOKOSC", false, attrs?.oS_ROZPIETOSC, props.version, props.objectType);
        var configValidationHeightWarnings = createConfigValidationWarnings("sT_WYSOKOSC", false, attrs?.oS_ROZPIETOSC, props.version, props.objectType);
        setConfigValidationSlopeHeight(configValidationHeight);
        setConfigValidationSlopeHeightWarnings(configValidationHeightWarnings);
        if (attrs?.oS_ROZPIETOSC !== null && attrs?.oS_ROZPIETOSC !== undefined &&
            attrs?.sT_WYSOKOSC !== null && attrs?.sT_WYSOKOSC !== undefined) {
                setErrorTipSlopeHeight("")
        } else {
            if(!pristineSlopeHeight) setErrorTipSlopeHeight(validation(configValidationHeight, attrs?.sT_WYSOKOSC));
        }

        const koD = CalcField.koDlugosc(attrs);
        const koDP = CalcField.hasKoDlugoscParams(attrs);
        var configValidationKoluviumWarnings = toFormulaConfig(koDP, koD, FormulaMsg.KoD);
        var configValidationKoluvium = createConfigValidation("kO_DLUGOSC", false, attrs?.oS_DLUGOSC);
        setConfigValidationKoluviumLength(configValidationKoluvium);
        setConfigValidationKoluviumLengthWarning(configValidationKoluviumWarnings);

        var configValidationMain = createConfigValidation("oS_DLUGOSC", false, attrs?.kO_DLUGOSC);
        setConfigValidationMainLength(configValidationMain);
        if (attrs?.oS_DLUGOSC !== null && attrs?.oS_DLUGOSC !== undefined &&
            attrs?.kO_DLUGOSC !== null && attrs?.kO_DLUGOSC !== undefined) {
            setErrorTipMainLength("");
        }
        else{
            if(!pristineMainLength) setErrorTipMainLength(validation(configValidationMain, attrs?.oS_DLUGOSC));
        }

        var configValidationMax = createConfigValidation("oS_WYS_MAKS", false, attrs?.oS_WYS_MIN);
        setConfigValidationMaxLength(configValidationMax);
        if (attrs?.oS_WYS_MAKS !== null && attrs?.oS_WYS_MAKS !== undefined &&
            attrs?.oS_WYS_MIN !== null && attrs?.oS_WYS_MIN !== undefined) {
            setErrorTipMaxLength("");
        }
        else{
            if(!pristineMaxLength) setErrorTipMaxLength(validation(configValidationMax, attrs?.oS_WYS_MAKS));
        }

        var configValidationMin = createConfigValidation("oS_WYS_MIN", false, attrs?.oS_WYS_MAKS);
        setConfigValidationMinLength(configValidationMin);
        if (attrs?.oS_WYS_MIN !== null && attrs?.oS_WYS_MIN !== undefined &&
            attrs?.oS_WYS_MAKS !== null && attrs?.oS_WYS_MAKS !== undefined) {
            setErrorTipMinLength("");
        }        
        else{
            if(!pristineMinLength) setErrorTipMinLength(validation(configValidationMin, attrs?.oS_WYS_MIN));
        }

        const osR = CalcField.osRozpietosc(attrs);
        const osRP = CalcField.hasOsRozpietoscParams(attrs);
        const configValRozpietoscWarn = toFormulaConfig(osRP, osR, FormulaMsg.OsR);
        setConfigValidationRozpietoscWarning(configValRozpietoscWarn);

        var configValidationNachylenieSkarpa = createConfigValidationWarnings("sG_NACHYLENIE", false, attrs?.oS_NACHYLENIE,
            undefined, undefined, attrs?.kO_NACHYLENIE);
        setConfigValidationNachylenieSkarpa(configValidationNachylenieSkarpa);
        if (attrs?.sG_NACHYLENIE !== null && attrs?.sG_NACHYLENIE !== undefined &&
            attrs?.oS_NACHYLENIE !== null && attrs?.oS_NACHYLENIE !== undefined) {
            setErrorTipNachylenieSkarpa("");
        }
        else{
            if(!pristineNachylenieSkarpa) setErrorTipMinLength(validation(configValidationNachylenieSkarpa, attrs?.sG_NACHYLENIE));
        }

        const koN = CalcField.koNachylenie(attrs);
        const koNP = CalcField.hasKoNachylenieParams(attrs);
        var configValidationNachylenieKoluv = createConfigValidationWarnings("kO_NACHYLENIE", false, attrs?.oS_NACHYLENIE);
        configValidationNachylenieKoluv.formula = toFormulaConfig(koNP, koN, FormulaMsg.KoN).formula;
        setConfigValidationNachylenieKoluv(configValidationNachylenieKoluv);

        var configValidationMszac = createConfigValidation("kO_MIAZSZOSC_SZAC", false, attrs?.kO_MIAZSZOSC_POM);
        var configValidationMszacWarning = createConfigValidationWarnings("kO_MIAZSZOSC_SZAC", false, attrs?.kO_WYS_CZOLA);
        setConfigValidationMszac(configValidationMszac);
        setConfigValidationMszacWarning(configValidationMszacWarning);
        if (attrs?.kO_MIAZSZOSC_SZAC !== null && attrs?.kO_MIAZSZOSC_SZAC !== undefined) {
            setErrorTipMszac("");
        }
        else{
            if(!pristineMszac) setErrorTipMszac(validation(configValidationMszac, attrs?.kO_MIAZSZOSC_SZAC));
        }

        var configValidationMpom = createConfigValidation("kO_MIAZSZOSC_POM", false, attrs?.kO_MIAZSZOSC_SZAC);
        var configValidationMpomWarning = createConfigValidationWarnings("kO_MIAZSZOSC_POM", false, attrs?.kO_WYS_CZOLA);
        setConfigValidationMpom(configValidationMpom);
        setConfigValidationMpomWarning(configValidationMpomWarning);
        if (attrs?.kO_MIAZSZOSC_POM !== null && attrs?.kO_MIAZSZOSC_POM !== undefined) {
            setErrorTipMpom("");
        }
        else{
            if(!pristineMpom) setErrorTipMpom(validation(configValidationMpom, attrs?.kO_MIAZSZOSC_POM));
        }

        var configValidationCzolo = createConfigValidationWarnings("kO_WYS_CZOLA", false, attrs?.kO_MIAZSZOSC_SZAC, 
        undefined, undefined, attrs?.kO_MIAZSZOSC_POM);
        setConfigValidationCzolo(configValidationCzolo);
        if (attrs?.kO_WYS_CZOLA !== null && attrs?.kO_WYS_CZOLA !== undefined) {
            setErrorTipCzolo("");
        }
        else{
            if(!pristineCzolo) setErrorTipCzolo(validation(configValidationCzolo, attrs?.kO_WYS_CZOLA));
        }

        if (props.version === PatternType.P2007) {
            const stN = CalcField.stNachylenie(attrs);
            const stNP = CalcField.hasStNachylenieParams(attrs);
            var configValidationNachylenieStokWarning = toFormulaConfig(stNP, stN, FormulaMsg.StN);
            var configValidationNachylenieStok = createConfigValidation("sT_NACHYLENIE", false, null, props.version, props.objectType);
            setConfigValidationNachylenieStok(configValidationNachylenieStok);
            setConfigValidationNachylenieStokWarning(configValidationNachylenieStokWarning);
        }

        setRerender(!rerender);

        // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [krForm.landslideAttributes?.sT_DLUGOSC, krForm.landslideAttributes?.sT_WYSOKOSC,
        krForm.landslideAttributes?.oS_DLUGOSC, krForm.landslideAttributes?.kO_DLUGOSC, krForm.landslideAttributes?.oS_ROZPIETOSC,
    krForm.landslideAttributes?.oS_WYS_MAKS, krForm.landslideAttributes?.oS_WYS_MIN, krForm.landslideAttributes?.sG_WYSOKOSC,
    krForm.landslideAttributes?.oS_NACHYLENIE, krForm.landslideAttributes?.kO_NACHYLENIE, krForm.landslideAttributes?.kO_MIAZSZOSC_SZAC,
    krForm.landslideAttributes?.kO_MIAZSZOSC_POM, krForm.landslideAttributes?.kO_WYS_CZOLA])

    const checkboxChange = (name: string, set: Function, state: boolean, setPristine?: Function) => {
        var form: any = Object.assign({}, krForm);
        if (!state && form !== null && form.landslideAttributes) {
            if (name === "sG_SKARPY_WTORNE") form.landslideAttributes[name as keyof landSlideAttributes] = "Nie występują";
            else form.landslideAttributes[name as keyof landSlideAttributes] = "Nie stwierdzono";
            setkrForm(form);
            set(true);
        }
        else {
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                setkrForm(form);
                set(false);
            }
        }
        if(setPristine){
            setPristine(false);
        }
    }

    const focusChange = (name: string, set: Function, state: boolean) => {
        if (state) {
            var form: any = krForm;
            if (form.landslideAttributes) {
                form.landslideAttributes[name as keyof landSlideAttributes] = "";
                setkrForm(form);
            }
            set(!state);
        }
    }

    // const blurChange = (event: any, name: string, set: Function, state: boolean) => {
    //     if (event.target.value == null || event.target.value === "") {
    //         var form = krForm;
    //         if (form.landslideAttributes) {
    //             if (!state) checkboxChange(name, set, state);
    //         }
    //     }
    // }

    const getInputProps = (KRFieldDict: KROFieldDict, fieldFormName: string, 
        alternateValidationConfig?: configValidation, errorTip?: string, reload?: boolean, validationConfigWarnings?: configValidation,
        pristine?: boolean
    ): FormFieldProps => {
        return {
            style: styleFormFieldHalf,
            type: "number",
            disabled: true,
            configValidation: alternateValidationConfig ? alternateValidationConfig : createConfigValidation("onlyRequired"),
            configValidationWarnings: validationConfigWarnings,
            validationError: ((errorTip != null && errorTip !== undefined && !pristine) || isFormNotValid || pristine === false),
            tipText: errorTip ? errorTip : undefined,
            reload: reload,
            pristine: pristine,
            addCommentBtn: getAddCommentBtnDetails(props.editMode!, KRFieldDict, fieldFormName, props.setNewCommentFieldDetails!),
            inputRef: (node: any) => {getFieldRef(node, KRFieldDict, props.getMapForComment!)},
            setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KRFieldDict); },
            isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KRFieldDict
        }
    }

    var textWithCheckboxPropsGaps: TextWithCheckBoxFieldProps = {
        textAreaProps: {
            labelName: is2007 ? 'Szczeliny powyżej skarpy głównej' : 'Szczeliny powyżej skarpy',
            textAreaPlaceholder: 'Dodaj opis',
            value: krForm.landslideAttributes?.sG_SZCZELINY,
            textareaSharedProps: {
                className: 'body-txt-large',
                style: {
                    width: '100%',
                    minHeight: '70px'
                }
            },
            onFocusText: () => { focusChange("sG_SZCZELINY", setGapsFound, gapsFound) },
            //onBlurText: (event: any) => { blurChange(event, "sG_SZCZELINY", setGapsFound, gapsFound) },
            setValue: (value: any) => {
                var form = krForm;
                if (form && form.landslideAttributes) {
                    form.landslideAttributes.sG_SZCZELINY = value;
                    setkrForm(form);
                    setRerender(!rerender);
                }
            },
            configValidation: createConfigValidation("onlyRequired"),
            validationError: isFormNotValid,
            pristine: pristineGaps,
            disabled: !props.editMode,
            addCommentBtn: getAddCommentBtnDetails(props.editMode!, KROFieldDict.paramMorf_skarGl_szczelinyPowyzejSkarpy, is2007 ? 'Szczeliny powyżej skarpy głównej' : 'Szczeliny powyżej skarpy', props.setNewCommentFieldDetails!),
            textareaRef: (node: any) => {getFieldRef(node, KROFieldDict.paramMorf_skarGl_szczelinyPowyzejSkarpy, props.getMapForComment!)},
            setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.paramMorf_skarGl_szczelinyPowyzejSkarpy); },
            isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KROFieldDict.paramMorf_skarGl_szczelinyPowyzejSkarpy,
            dynamicResize: true
        },
        checkBoxProps: {
            onChange: () => { checkboxChange("sG_SZCZELINY", setGapsFound, gapsFound, setPristineGaps) },
            labelName: 'Nie stwierdzono',
            inputChecked: gapsFound,
            disabled: !props.editMode
        }
    }

    var textWithCheckboxPropsSecondarySlopes: TextWithCheckBoxFieldProps = {
        textAreaProps: {
            labelName: is2007 ? 'Skarpy wtórne' : 'Skarpy drugorzędne',
            textAreaPlaceholder: 'Dodaj opis',
            value: krForm.landslideAttributes?.sG_SKARPY_WTORNE,
            textareaSharedProps: {
                className: 'body-txt-large',
                style: {
                    width: '100%',
                    minHeight: '70px'
                }
            },
            onFocusText: () => { focusChange("sG_SKARPY_WTORNE", setSecondarySlopes, secondarySlopes) },
            //onBlurText: (event: any) => { blurChange(event, "sG_SKARPY_WTORNE", setSecondarySlopes, secondarySlopes) },
            setValue: (value: any) => {
                var form = Object.assign({}, krForm);
                if (form && form.landslideAttributes) {
                    form.landslideAttributes.sG_SKARPY_WTORNE = value;
                    setkrForm(form);
                }
            },
            configValidation: createConfigValidation("onlyRequired"),
            validationError: isFormNotValid,
            pristine: pristineSecondarySlopes,
            disabled: !props.editMode,
            addCommentBtn: getAddCommentBtnDetails(props.editMode!, KROFieldDict.paramMorf_skarGl_skarpyDrugorzedne, is2007 ? 'Skarpy wtórne' : 'Skarpy drugorzędne', props.setNewCommentFieldDetails!),
            textareaRef: (node: any) => {getFieldRef(node, KROFieldDict.paramMorf_skarGl_skarpyDrugorzedne, props.getMapForComment!)},
            setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.paramMorf_skarGl_skarpyDrugorzedne); },
            isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KROFieldDict.paramMorf_skarGl_skarpyDrugorzedne,
            dynamicResize: true
        },
        checkBoxProps: {
            onChange: () => { checkboxChange("sG_SKARPY_WTORNE", setSecondarySlopes, secondarySlopes, setPristineSecondarySlopes) },
            labelName: 'Nie występują',
            inputChecked: secondarySlopes,
            disabled: !props.editMode
        }
    }

    const setValue = (value: any, name: string) => {
        let attrs = {...krForm.landslideAttributes} as landSlideAttributes;
        if (attrs) attrs[name as keyof landSlideAttributes] = value;

        if (name === "sG_WYSOKOSC" || name === "oS_DLUGOSC" || name === "sG_NACHYLENIE") {
            attrs.kO_DLUGOSC = CalcField.koDlugosc(attrs);
            attrs.kO_NACHYLENIE = CalcField.koNachylenie(attrs);
        }
        if (name === "oS_NACHYLENIE" || name === "kO_DLUGOSC") {
            attrs.kO_NACHYLENIE = CalcField.koNachylenie(attrs);
        }
        if (name === "sT_DLUGOSC" || name === "sT_WYSOKOSC") {
            attrs.sT_NACHYLENIE = CalcField.stNachylenie(attrs);
        }
        if (name === "oS_WYS_MAKS" || name === "oS_WYS_MIN") {
            attrs.oS_ROZPIETOSC = CalcField.osRozpietosc(attrs);
        }
        if (name === "oS_WYS_MAKS" || name === "oS_WYS_MIN" || name === "oS_DLUGOSC") {
            attrs.oS_NACHYLENIE = CalcField.osNachylenie(attrs);
        }

        let newForm = {...krForm, landslideAttributes: attrs};
        setkrForm(newForm);
    }

    const selectOnChange = (opt: Option[] | undefined, name: string) => {
        var form = Object.assign({}, krForm) as KrLandslideFormTypes;
        var landslideForm = form as KrLandslideFormTypes;
        if (landslideForm.landslideAttributes) {
            if (opt) {
                const option = opt.length > 0 ? opt[0] : null;
                landslideForm.landslideAttributes[name as keyof landSlideAttributes] = option?.value as number;
            } else {
                landslideForm.landslideAttributes[name as keyof landSlideAttributes] = null;
            }
        }
        setkrForm(form);
    }

    const getConfigValidation = (name: string) => {
        return createConfigValidation(name, false, undefined, props.version, props.objectType);
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.MorfologicalParameters, props.getMapForNavScroll!)} style={{ width: '100%' }}>4. Parametry morfologiczne {is2007 && "osuwiska"} </h2>

            <h3 style={{ width: '100%' }}>Ogólne</h3>
            <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_powierzchnia, "Powierzchnia [ha]", createConfigValidation("oS_POWIERZCHNIA"))} 
                labelName="Powierzchnia [ha]" 
                value={CalcField.haArea(krForm.landslideAttributes?.oS_POWIERZCHNIA)} 
                style={styleFormFieldHalf} 
            />
            <div style={styleFormFieldHalf}></div>
            <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_dlugosc, "Długość - Ogólne", configValidationMainLength, errorTipMainLength, rerender, undefined, pristineMainLength)} 
                labelName="Długość [m]" 
                setValue={(value) => { setValue(value, "oS_DLUGOSC"); setPristineMainLength(false); setPristineKoluviumLength(false); setPristineNachylenieKoluv(false); }} 
                value={krForm.landslideAttributes?.oS_DLUGOSC} style={styleFormFieldHalf} 
                disabled={!props.editMode}
                type="text"
                onlyDigits={true}
                min={1}
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_szerokosc, "Szerokość - Ogólne", createConfigValidation("oS_SZEROKOSC"))} 
                labelName="Szerokość [m]" 
                setValue={(value) => { setValue(value, "oS_SZEROKOSC") }} 
                value={krForm.landslideAttributes?.oS_SZEROKOSC} 
                style={styleFormFieldHalf} 
                disabled={!props.editMode} 
                type="text"
                onlyDigits={true}
                min={1}
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_wysokoscMaksymalna, "Wysokość maksymalna", configValidationMaxLength, errorTipMaxLength, rerender, undefined, pristineMaxLength)} 
                labelName="Wysokość maksymalna [m n.p.m.]" 
                setValue={(value) => { setValue(value, "oS_WYS_MAKS"); setPristineMaxLength(false); setPristineRozpietosc(false); }} 
                value={krForm.landslideAttributes?.oS_WYS_MAKS} 
                style={styleFormFieldHalf} 
                disabled={!props.editMode}
                type="text"
                onlyDigits={true}
                min={-2}
                max={2500}
                allowNegatives={true}
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_wysokoscMinimalna, "Wysokość minimalna", configValidationMinLength, errorTipMinLength, rerender, undefined, pristineMinLength)} 
                labelName="Wysokość minimalna [m n.p.m.]" 
                setValue={(value) => { setValue(value, "oS_WYS_MIN"); setPristineMinLength(false); setPristineRozpietosc(false); }} 
                value={krForm.landslideAttributes?.oS_WYS_MIN} 
                style={styleFormFieldHalf} 
                disabled={!props.editMode} 
                pattern="-?\d+"
                type="text"
                onlyDigits={true}
                min={-2}
                max={2500}
                allowNegatives={true}
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_rozpietoscPionowa, "Rozpiętość pionowa", createConfigValidation("oS_ROZPIETOSC"), undefined,
            rerender, configValidationRozpietoscWarning, pristineRozpietosc)} 
                labelName="Rozpiętość pionowa [m]" 
                value={krForm.landslideAttributes?.oS_ROZPIETOSC} 
                style={styleFormFieldHalf}
                type="text"
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_nachylenie, "Nachylenie - Ogólne", createConfigValidation("oS_NACHYLENIE"))} 
                labelName="Nachylenie [°]" 
                setValue={(value) => { setValue(value, "oS_NACHYLENIE"); setPristineNachylenieKoluv(false);  }} 
                value={krForm.landslideAttributes?.oS_NACHYLENIE} 
                style={styleFormFieldHalf} 
                disabled={!props.editMode}
                type="text"
                onlyDigits={true}
                min={1}
                max={90}
            />
            {is2007 && <FormField {...getInputProps(KROFieldDict.paramMorf_ogolne_azymut, "Azymut", createConfigValidation("oS_AZYMUT", false, undefined, props.version, props.objectType))} 
                labelName="Azymut [°]" 
                setValue={(value) => { setValue(value, "oS_AZYMUT") }} 
                value={krForm.landslideAttributes?.oS_AZYMUT} 
                style={styleFormFieldHalf} 
                disabled={!props.editMode}
                type="text"
                onlyDigits={true}
                min={0}
                max={359}
            />}

            <h3 style={{ width: '100%' }}>{is2007 ? "Skarpa osuwiskowa" : "Skarpa główna"}</h3>
            <FormField {...getInputProps(KROFieldDict.paramMorf_skarGl_wysokosc, is2007 ? "Wysokość skarpy głównej" : "Wysokość - Skarpa główna", createConfigValidation("sG_WYSOKOSC"), undefined, undefined, createConfigValidationWarnings("sG_WYSOKOSC"))} 
                labelName={is2007 ? "Wysokość skarpy głównej [m]" : "Wysokość [m]"} 
                setValue={(value) => { setValue(value, "sG_WYSOKOSC"); setPristineKoluviumLength(false); setPristineNachylenieKoluv(false); }} 
                value={krForm.landslideAttributes?.sG_WYSOKOSC} 
                style={styleFormFieldHalf} 
                disabled={!props.editMode} 
                type="text"
                withDecimals={true}
                decimalPlaces={2}
                min={0}
                max={2000}
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_skarGl_nachylenie, is2007 ? "Nachylenie skarpy głównej" : "Nachylenie - Skarpa główna", createConfigValidation("sG_NACHYLENIE"), errorTipNachylenieSkarpa, rerender, configValidationNachylenieSkarpa, pristineNachylenieSkarpa)} 
                labelName={is2007 ? "Nachylenie skarpy głównej [°]" : "Nachylenie [°]"} 
                setValue={(value) => { setValue(value, "sG_NACHYLENIE"); setPristineNachylenieSkarpa(false); setPristineKoluviumLength(false); }} 
                value={krForm.landslideAttributes?.sG_NACHYLENIE} 
                style={styleFormFieldHalf} 
                disabled={!props.editMode} 
                type="text"
                onlyDigits={true}
                min={0}
                max={90}
            />
            <TextWithCheckboxField {...textWithCheckboxPropsGaps} />
            <TextWithCheckboxField {...textWithCheckboxPropsSecondarySlopes} />

            <h3 style={{ width: '100%' }}>{is2007 ? "Jęzor i koluwium" : "Koluwium"}</h3>
            <FormField {...getInputProps(KROFieldDict.paramMorf_koluw_wysokoscCzola, "Wysokość czoła", createConfigValidation("kO_WYS_CZOLA"), errorTipCzolo, rerender, configValidationCzolo, pristineCzolo)} 
                labelName="Wysokość czoła [m]" 
                setValue={(value) => { setValue(value, "kO_WYS_CZOLA"); setPristineCzolo(false) }} 
                value={krForm.landslideAttributes?.kO_WYS_CZOLA}
                disabled={!props.editMode} 
                type="text"
                withDecimals={true}
                decimalPlaces={1}
                min={0}
                max={Infinity}
                />
            <FormField {...getInputProps(KROFieldDict.paramMorf_koluw_dlugosc, "Długość - Koluwium", configValidationKoluviumLength, undefined, rerender, configValidationKoluviumLengthWarning, pristineKoluviumLength)} 
                labelName="Długość [m]" 
                setValue={(value) => { setValue(value, "kO_DLUGOSC"); setPristineKoluviumLength(false) }} 
                value={krForm.landslideAttributes?.kO_DLUGOSC} 
                disabled={!props.editMode} 
                type="text"
                onlyDigits={true}
                min={1}
                max={5000}
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_koluw_nachylenie, "Nachylenie - Koluwium", createConfigValidation("kO_NACHYLENIE"), undefined, rerender, configValidationNachylenieKoluv, pristineNachylenieKoluv)} 
                labelName="Nachylenie [°]" 
                setValue={(value) => { setValue(value, "kO_NACHYLENIE"); setPristineNachylenieKoluv(false) }} 
                value={krForm.landslideAttributes?.kO_NACHYLENIE} 
                disabled={!props.editMode} 
                type="text"
                onlyDigits={true}
                min={0}
                max={90}
            />
            <div style={styleFormFieldHalf}></div>
            <FormField {...getInputProps(KROFieldDict.paramMorf_koluw_miazszoscMierzona, "Miąższość mierzona", configValidationMpom, errorTipMpom, rerender, configValidationMpomWarning, pristineMpom)} 
                labelName="Miąższość mierzona [m]" 
                setValue={(value) => { setValue(value, "kO_MIAZSZOSC_POM"); setPristineMpom(false) }} 
                value={krForm.landslideAttributes?.kO_MIAZSZOSC_POM} 
                disabled={!props.editMode} 
                type="text"
                withDecimals={true}
                decimalPlaces={2}
                min={1}
                max={300}
            />
            <FormField {...getInputProps(KROFieldDict.paramMorf_koluw_miazszoscSzacowana, "Miąższość szacowana", configValidationMszac, errorTipMszac, rerender, configValidationMszacWarning, pristineMszac)} 
                labelName="Miąższość szacowana [m]" 
                setValue={(value) => { setValue(value, "kO_MIAZSZOSC_SZAC"); setPristineMszac(false) }} 
                value={krForm.landslideAttributes?.kO_MIAZSZOSC_SZAC} 
                disabled={!props.editMode} 
                type="text"
                withDecimals={true}
                decimalPlaces={2}
                min={1}
                max={300}
            />

            {is2007 &&
                <>
                    <h3 style={{ width: '100%' }}>Stok, na którym jest osuwisko</h3>
                    <SelectInput 
                        style={styleFormFieldHalf} 
                        label="Typ stoku" 
                        validationError={isFormNotValid}
                        tipText={errorTipsText["tyP_STOKU_SID"]}
                        pristine={true}
                        reload={reload}
                        hasInputTags={true} 
                        options={slopeTypeDict} 
                        onlySingleTag={true}
                        selectedOptions={prepareDataSingleForSelect(slopeTypeDict, undefined, krForm.landslideAttributes?.tyP_STOKU_SID)}
                        onChange={(opt: Option[] | undefined) => {selectOnChange(opt, "tyP_STOKU_SID")}}
                        configValidation={getConfigValidation("tyP_STOKU_SID")}
                        disabled={!props.editMode}
                        addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.paramMorf_stokOsuw_typStoku, "Typ stoku", props.setNewCommentFieldDetails!)}
                        selectRef={(node: any) => {getFieldRef(node, KROFieldDict.paramMorf_stokOsuw_typStoku, props.getMapForComment!)}} 
                        setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.paramMorf_stokOsuw_typStoku); }}
                        isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.paramMorf_stokOsuw_typStoku}
                    />
                    <FormField {...getInputProps(KROFieldDict.paramMorf_stokOsuw_nachylenie, "Nachylenie - Stok, na którym jest osuwisko", configValidationNachylenieStok, undefined, rerender, configValidationNachylenieStokWarning, pristineNachylenieStok)} 
                        labelName="Nachylenie [°]"
                        setValue={(value) => { setValue(value, "sT_NACHYLENIE"); setPristineNachylenieStok(false); }}
                        value={krForm.landslideAttributes?.sT_NACHYLENIE} 
                        style={styleFormFieldHalf} 
                    />
                    <SelectInput 
                        style={styleFormFieldHalf} 
                        label="Ekspozycja" 
                        validationError={isFormNotValid}
                        hasInputTags={true} 
                        options={exposureDirectionDict} 
                        onlySingleTag={true}
                        selectedOptions={prepareDataSingleForSelect(exposureDirectionDict, undefined, krForm.landslideAttributes?.kieruneK_EKSPOZYCJI_SID)}
                        onChange={(opt: Option[] | undefined) => {selectOnChange(opt, "kieruneK_EKSPOZYCJI_SID")}}
                        configValidation={getConfigValidation("kieruneK_EKSPOZYCJI_SID")} 
                        disabled={!props.editMode}
                        addCommentBtn={getAddCommentBtnDetails(props.editMode!, KROFieldDict.paramMorf_stokOsuw_ekspozycja, "Ekspozycja", props.setNewCommentFieldDetails!)}
                        selectRef={(node: any) => {getFieldRef(node, KROFieldDict.paramMorf_stokOsuw_ekspozycja, props.getMapForComment!)}} 
                        setCommentsFilter={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.paramMorf_stokOsuw_ekspozycja); }}
                        isMarkedForCommentFilter={props.markedFieldForCommentFiltering === KROFieldDict.paramMorf_stokOsuw_ekspozycja}
                    />
                    <FormField {...getInputProps(KROFieldDict.paramMorf_stokOsuw_dlugosc, "Długość - Stok, na którym jest osuwisko", configValidationSlopeLength, errorTipSlopeLength, rerender, configValidationSlopeLengthWarnings, pristineSlopeLength)} 
                        labelName="Długość [m]"
                        setValue={(value) => { setValue(value, "sT_DLUGOSC"); setPristineSlopeLength(false); setPristineNachylenieStok(false); }} 
                        value={krForm.landslideAttributes?.sT_DLUGOSC} 
                        style={styleFormFieldHalf} 
                        disabled={!props.editMode} 
                        type="text"
                        onlyDigits={true}
                        min={1}
                        max={5000}
                    />
                    <FormField {...getInputProps(KROFieldDict.paramMorf_stokOsuw_wysokosc, "Wysokość - Stok, na którym jest osuwisko", configValidationSlopeHeight, errorTipSlopeHeight, rerender, configValidationSlopeHeightWarnings, pristineSlopeHeight)} 
                        labelName="Wysokość [m]" 
                        setValue={(value) => { setValue(value, "sT_WYSOKOSC"); setPristineSlopeHeight(false); setPristineNachylenieStok(false); }} 
                        value={krForm.landslideAttributes?.sT_WYSOKOSC} 
                        style={styleFormFieldHalf} 
                        disabled={!props.editMode} 
                        type="text"
                        onlyDigits={true}
                        min={1}
                        max={2000}
                    />
                </>
            }
        </>
    )
}

export default MorfologicalParameters;